<template>
  <div
    v-if="isLoggedIn && !isSidebarHidden"
    :class="{hide:isContentsHidden}">
    <header
      class="header">
      <div class="header-inner">
        <div class="header-wrap">
          <h1
            class="header__logo"
            :class="{ 'header__logo__left' : isBtoC }">
            <router-link :to="{ name: 'index' }">
              <img
                :src="isBtoC?`/img/narasu/logo${mateLogSuffix}.png`:
                  `/img/common/logo-${appName.toLowerCase()}.png`"
                :alt="isBtoC?`narasu${mateAltSuffix}`:appName">
            </router-link>
          </h1>
          <button
            ref="spmenubtn"
            class="menu-btn sp">
            <span
              ref="spsubmenu"
              class="menu-btn__box">
            </span>
          </button>
        </div>
      </div>
    </header>
    <div class="content">
      <div
        v-if="isLaunched"
        class="menu-wrap">
        <side-menu />
      </div>
      <div class="main-container">
        <loading
          background-color="#000"
          :opacity="0.5"
          :active.sync="isLoading"
          :is-full-page="true">
          <div v-if="loadedProgress>0">
            <div class="upload-filename">
              {{ uploadFilename }}
            </div>
            <progress-bar
              style="width: 60vmin;margin-bottom: 20px"
              text-align="center"
              size="large"
              :bar-color="isBtoC?'#ff2289':'#ff6c01'"
              bg-color="#000"
              :font-size="10"
              text-fg-color="#fff"
              :val="loadedProgress"
              :text="progressText">
            </progress-bar>
            <div
              v-for="(lineString, loadingIndex) of description.split('\n')"
              :key="`loadingIndex${loadingIndex}`"
              class="upload-description">
              {{ lineString }}<br />
            </div>
          </div>
        </loading>

        <div
          v-if="hasSystemMessage"
          class="system-message mt-10 error-block__title error-block">
          <pre>{{ $store.state.systemMessage.message }}</pre>
        </div>

        <router-view />
        <footer-content />
      </div>
    </div>
  </div>
  <div
    v-else
    :class="{hide:isContentsHidden}">
    <header class="header header-secondary">
      <h1 class="header-secondary__logo">
        <router-link :to="{ name: 'index' }">
          <img
            :src="isBtoC?'/img/narasu/logo.png':`/img/common/logo-${appName.toLowerCase()}.png`"
            :alt="isBtoC?'narasu':appName">
        </router-link>
      </h1>
      <button class="menu-btn sp">
        <span class="menu-btn__box"></span>
      </button>
      <nav class="header-secondary-nav">
        <ul class="header-secondary-nav__list">
          <li
            v-for="(content, index) in contents"
            :key="index"
            class="header-secondary-nav__node">
            <a :href="content.path">{{ content.title }}</a>
          </li>
        </ul>
      </nav>
    </header>
    <div
      class="content content--secondary">
      <!-- ナビ-->
      <div class="menu-wrap sp">
        <nav class="menu">
          <ul class="menu-list">
            <li class="menu-list__node menu-list__help active">
              <ul class="menu-list-child">
                <li
                  v-for="(content, index) in contents"
                  :key="index"
                  class="menu-list-child__node">
                  <a :href="content.path">{{ content.title }}</a>
                </li>
              </ul>
            </li>
          </ul>
        </nav>
      </div>
      <router-view />
    </div>
    <footer-content />
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import ProgressBar from 'vue-simple-progress'
import 'vue-loading-overlay/dist/vue-loading.css'
import { mapGetters } from 'vuex'
import SideMenu from './SideMenu'
import FooterContent from './FooterContent'

export default {
  components: {
    SideMenu,
    FooterContent,
    Loading,
    ProgressBar,
  },
  data() {
    return {
      timer: null,
      mateLogSuffix: '-unknown',
      mateAltSuffix: 'unknown',
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn', 'isMate', 'mateType']),
    ...mapGetters('progress', ['loadedProgress', 'progressText', 'uploadFilename', 'description']),
    ...mapGetters(['isSidebarHidden', 'isContentsHidden']),
    isLoading() {
      return this.$store.getters.hasPendingAjax
    },
    contents() {
      if (this.appName === 'N-MAP') {
        return [
          { title: '推奨環境', path: '/client/static/environment' },
        ]
      }
      if (this.isBtoC) {
        return [
          { title: 'よくある質問', path: '/client/static/faqs' },
          { title: 'ストア詳細', path: '/client/static/store-detail' },
          { title: '利用規約', path: '/client/static/terms' },
          { title: '著作権管理サービス利用規約', path: '/client/static/copyright-terms' },
          { title: '配信規定', path: '/client/static/rules' },
          { title: '推奨環境', path: '/client/static/environment' },
          { title: 'お問い合わせ', path: '/client/contact' },
        ]
      }
      return [
        { title: 'ストア詳細', path: '/client/static/store-detail' },
        { title: '利用規約', path: '/client/static/terms' },
        { title: '放送二次使用料規約', path: '/client/static/zu-map-secondary-usage-fee-for-broadcasts-terms' },
        { title: '推奨環境', path: '/client/static/environment' },
        { title: 'お問い合わせ', path: '/client/contact' },
      ]
    },
    hasSystemMessage: {
      get() {
        const hasMessage = this.$store.state.systemMessage.global
          && this.$store.state.systemMessage.show
        if (hasMessage) {
          this.delayClose()
        }
        return hasMessage
      },
      set(value) {
        if (!value) {
          this.$store.commit('resetSystemMessage')
        }
      },
    },
  },
  watch: {
    '$route.query': {
      handler() {
        const openedMenu  = document.querySelector('.menu-btn--open')
        if (openedMenu) openedMenu.click()
      },
    },
    '$route.path': {
      handler() {
        window.scrollTo(0, 0)
      },
    },
    mateType: {
      handler() {
        switch (this.mateType) {
          case -1:
            this.mateLogSuffix = '-unknown'
            this.mateAltSuffix = 'unknown'
            sessionStorage.setItem('narasuMate', 'unknown')
            break
          case 1:
            this.mateLogSuffix = '-mate'
            this.mateAltSuffix = 'Mate'
            sessionStorage.setItem('narasuMate', 'mate')
            break
          case 2:
            this.mateLogSuffix = '-mate-plus'
            this.mateAltSuffix = 'Mate+'
            sessionStorage.setItem('narasuMate', 'mate-plus')
            break
          case 3:
            this.mateLogSuffix = '-life'
            this.mateAltSuffix = 'Life'
            sessionStorage.setItem('narasuMate', 'life')
            break
          default:
            this.mateLogSuffix = ''
            sessionStorage.setItem('narasuMate', '')
            break
        }
      },
    },
  },
  mounted() {
  },
  methods: {
    delayClose() {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.hasSystemMessage = false
      }, 5000)
    },
  },
}
</script>

<style scoped>
.upload-filename {
  text-align: center;
  color: #fff;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 60vmin;
  margin: auto auto;
}
.upload-description {
  text-align: center;
  color: #fff;
  font-size: 16px;
}
@media screen and (max-width: 895px) {
  .upload-description {
    text-align: center;
    color: #fff;
    font-size: 12px;
  }
}
@media screen and (min-width: 896px) {
  .vld-overlay {
    padding-left: 280px;
  }
  .header__logo__left {
    left: 55px;
  }
}
.hide{
  display:none;
}
</style>
